import WinlinesView from "../../../vendor_core/core/src/views/WinlinesView";
import { Elastic, TimelineMax, TweenMax } from "gsap";
import SymbolAnimation from "../../../vendor_core/core/src/views/SymbolAnimation";
import Trail from "./Trail";
import SceneView from "../../../vendor_core/core/src/views/SceneView";
import WinSymbolsView from "../../../vendor_core/core/src/views/WinSymbolsView";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import BBReelGroup from "./BBReelGroup";
import SoundVars from "../../../vendor_core/core/src/const/SoundVars";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import TextField from "../../../vendor_core/core/src/views/components/TextField";
import Utils from "../../../vendor_core/core/src/utils/Utils";
import { MoneyField } from "../../../vendor_core/core/src/views/MoneyField";
import BBModel from "../model/BBModel";
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import Layout from "../../../vendor_core/core/src/utils/Layout";
import { Container, DisplayObject, Graphics, Point, Rectangle } from "pixi.js";
import { IWinData } from "../../../vendor_core/core/src/server/data/ISpinData";
import App from "../../../vendor_core/core/src/App";
import ReelSymbol from "../../../vendor_core/core/src/views/Symbol";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { BitmapMoneyField } from "../../../vendor_core/core/src/views/BitmapMoneyField";
import { BitmapMoneyFieldConfig } from "../../../vendor_core/core/src/views/AbstractBitmapMoneyField";
import BitmapTextField from "../../../vendor_core/core/src/views/components/BitmapTextField";
import BBFixTextPositions from "../utils/BBFixTextPositions";

export default class BBWinlinesView extends WinlinesView {
    private winSymbolsView: WinSymbolsView;
    private reelGroup: BBReelGroup;
    private winBannerMegaValue = 0;
    private multiMegaValue = 1;
    private multiSfxCounter = 1;
    private colorMap = {
        // 0 is used for overlapping mega color, if this field is set to true
        // see useSingleMegaColorOnOverlap field
        0: "gold",
        1: "red",
        2: "blue",
        3: "purple",
        4: "orange",
        5: "green",
        6: "yellow",
    };

    private debugDrawClusterBounds: boolean = false;
    private debugDrawClusterBoundsPrefix: string = "debug_draw_cluster_bounds";
    private useSingleMegaColorOnOverlap: boolean = false;

    private travelSumsToWildDelayTime = 0.5;
    private travelToWildTime = 0.4;
    private popUpTime = {
        max: 0.35,
        min: 0.15,
    };

    public bannerScalars = {
        downScaleMultiplier: 1,
        downScaleMultiplierY: 1,
        upScaleMultiplier: 1.7,
        upScaleMultiplierY: 2.5,
    };

    public multiScalars = {
        downScaleMultiplier: 1,
        downScaleMultiplierY: 1,
        upScaleMultiplier: 1.7,
        upScaleMultiplierY: 1.7,
    };

    public bannerBoundScalar = {
        upScaleMultiplier: 1.7,
        upScaleMultiplierY: 2.5
    }

    public multiplierSpacing = 12.5;

    public symbolScalar = 0.8;
    public symbolScalarY = 0.4;

    private showX1MultiplierComboText: boolean = true;

    create(
        scene: SceneView,
        paylineLayer?: string,
        celebrationsLayer?: string,
        reelHeight?: number
    ) {
        super.create(scene, paylineLayer, celebrationsLayer, reelHeight);

        this.reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .getSubView("ReelGroup") as BBReelGroup;

        this.winSymbolsView = this.reelGroup.winSymbolsView;
    }

    // Responsive setup
    public setResponsiveScaling() {
        if (GameModel.isMobile() && Layout.isLandscape()) {
            this.bannerScalars = {
                downScaleMultiplier: 1.5,
                downScaleMultiplierY: 1.5,
                upScaleMultiplier: 1.6,
                upScaleMultiplierY: 2.15,
            };
            this.multiScalars = {
                downScaleMultiplier: 1.5,
                downScaleMultiplierY: 1.5,
                upScaleMultiplier: 2.3,
                upScaleMultiplierY: 2.3,
            };

            this.bannerBoundScalar = {
                upScaleMultiplier: 1.7,
                upScaleMultiplierY: 2
            }

            this.symbolScalar = 0.8;
            this.symbolScalarY = 0.5;
        } else if (GameModel.isMobile() && !Layout.isLandscape()) {
            this.bannerScalars = {
                downScaleMultiplier: 1.5,
                downScaleMultiplierY: 1.5,
                upScaleMultiplier: 1.6,
                upScaleMultiplierY: 2.6,
            };
            this.multiScalars = {
                downScaleMultiplier: 1.5,
                downScaleMultiplierY: 1.5,
                upScaleMultiplier: 2.3,
                upScaleMultiplierY: 2.3,
            };

            this.bannerBoundScalar = {
                upScaleMultiplier: 1.7,
                upScaleMultiplierY: 2,
            }

            this.symbolScalar = 0.8;
            this.symbolScalarY = 0.5;
        } else if (!GameModel.isMobile()) {
            this.multiScalars = {
                downScaleMultiplier: 1.8,
                downScaleMultiplierY: 1.8,
                upScaleMultiplier: 2.4,
                upScaleMultiplierY: 2.4,
            };
            this.symbolScalar = 1.1;
            this.bannerBoundScalar = {
                upScaleMultiplier: 1.7,
                upScaleMultiplierY: 2,
            }
        }
    }


    public createTrail(group: { x: number; y: number }[], index: number) {
        let currentAnim = this.winSymbolsView.getAnimAtReelCell(
            group[index].x - 1,
            group[index].y - 1
        );

        for (let i = index + 1; i < group.length; i++) {
            // If it's the next reel
            if (group[i].x == group[index].x + 1) {
                if (Math.abs(group[i].y - group[index].y) <= 1) {
                    // And if it's directly connected to the previous one
                    let nextAnim = this.winSymbolsView.getAnimAtReelCell(
                        group[i].x - 1,
                        group[i].y - 1
                    );

                    TweenMax.delayedCall(
                        (group[i].x - 1) * 0.2,
                        () => {
                            this.runTrail(currentAnim, nextAnim);
                        },
                        [],
                        this
                    );
                }
            }
        }
    }

    private runTrail(currentAnim: SymbolAnimation, nextAnim: SymbolAnimation) {
        // console.log("TRAIL");
        let trail = new Trail(
            new PIXI.Point(currentAnim.x, currentAnim.y),
            new PIXI.Point(nextAnim.x, nextAnim.y),
            () => {
                trail = null;
            }
        );
        this.winFrameContainer.addChild(trail);
    }

    protected hideAll(displayObjects: DisplayObject[]): void {
        displayObjects.forEach((displayObject) => {
            if (!!displayObject) {
                displayObject.visible = false;
            }
        });
    }
    protected showAll(displayObjects: DisplayObject[]): void {
        displayObjects.forEach((displayObject) => {
            if (!!displayObject) {
                displayObject.visible = true;
            }
        });
    }

    public setGroupWinBannersValue(
        value: number,
        x: any,
        y: any,
        winData: any,
        lastBanner: boolean,
        wild?: ReelSymbol
    ) {
        this.setResponsiveScaling();
        const layer = ViewManager.getLayer(DefaultLayers.PaylineCelebration);
        const layer1 = ViewManager.getLayer(DefaultLayers.Paylines);
        layer.clear();
        const scene = layer.getOrphanedScene("win");
        const sceneMega = layer.getOrphanedScene("win");
        const paylineScene = layer1.getCurrentScene();
        const winBanner = scene.sceneMoneyFields.get(
            "w_value"
        ) as BitmapMoneyField;
        const multi = scene.sceneTextFields.get("w_multi") as BitmapTextField;
        paylineScene.addSubView(winBanner, "banner", "lines");
        const winBannerMegaCluster = sceneMega.sceneMoneyFields.get(
            "w_value"
        ) as BitmapMoneyField;
        const multiMegaCluster = sceneMega.sceneTextFields.get(
            "w_multi"
        ) as BitmapTextField;

        this.hideAll([
            winBanner,
            multi,
            winBannerMegaCluster,
            multiMegaCluster,
        ]);

        if (wild) {
            let multipliers =
                BBModel.getCurrentSpinProperty("multiplierBefore");
            multi.text = "X" + multipliers[winData.winSymId - 1];
        } else {
            multi.text = "X" + winData.multiplier;
        }

        SoundController.playSound(SoundVars.EFFECT_TAKEWIN);

        // Computing the current win group bounding box.
        let winGroupBound = this.computeWinningSymbolsBound(winData);
        // And setting the point to the bb center.
        x = winGroupBound.x + winGroupBound.width / 2;
        y = winGroupBound.y + winGroupBound.height / 2;

        let local = this.reelGroup.children[0].toLocal(new Point(x, y));

        this.setPositionsAndPivot(
            multi,
            winBanner,
            winBannerMegaCluster,
            multiMegaCluster,
            local.x,
            local.y,
            paylineScene
        );

        this.onOrientationChange = () => {
            this.setPositionsAndPivot(
                multi,
                winBanner,
                winBannerMegaCluster,
                multiMegaCluster,
                local.x,
                local.y,
                paylineScene
            );
        };

        this.changeColor(winBannerMegaCluster, multiMegaCluster, winData);
        this.changeColor(winBanner, multi, winData);

        if (winData.multiplier > 1 && !wild) {
            winBanner.value = value / winData.multiplier;
        } else if (wild) {
            winBanner.value = value / winData.multiplier;
        } else {
            winBanner.value = value;
        }

        let tl: TimelineMax;
        if (wild) {
            tl = this.addCustomTweens(
                winBanner,
                multi,
                value,
                paylineScene,
                wild,
                winBannerMegaCluster,
                multiMegaCluster,
                lastBanner,
                winData
            );
        } else {
            tl = this.addCustomTweens(
                winBanner,
                multi,
                value,
                paylineScene,
                wild
            );
        }

        tl.play();
        return { tl, winBanner, multi };
    }

    /**
     * Computes the bounding box in a global coordinates for a group of win symbols.
     *
     * @private
     * @param {IWinData} winData The win data, which contains the winning symbol coordinates.
     * @return {*}  {Rectangle}
     * @memberof BBWinlinesView
     */
    private computeWinningSymbolsBound(
        winData: IWinData,
        allowDebugDraw: boolean = true
    ): Rectangle {
        let bounds: Rectangle = undefined;

        winData.coordinates.forEach((c) => {
            // windata is 1 based
            let symBounds = this.getSymbolBound(c.x - 1, c.y - 1);

            if (!bounds) {
                bounds = symBounds;
            } else {
                bounds.enlarge(symBounds);
            }
        });

        if (this.debugDrawClusterBounds && allowDebugDraw) {
            let rect = new Graphics();
            rect.beginFill(
                0x000000,
                this.hasOverlappingMegaBounds()
                    ? 0.1 / SpinModel.getCurrentWinsData().length
                    : 0.1
            );
            rect.lineStyle(2, 0xbbbbbb);
            rect.drawRect(bounds.x, bounds.y, bounds.width, bounds.height);
            rect.name = this.debugDrawClusterBoundsPrefix + Math.random();
            App.instance.stage.addChild(rect);
        }

        return bounds;
    }

    private getSymbolBound(reelId: number, rowId: number) {
        // Getting only the default symbol sprite,
        // in order to compute more precise bounds.
        // For example the current implementation
        // uses spine animations, which has bigger bounds
        // which we wish to ignore.
        let symBounds = this.reelGroup
            .getSymbolAt(reelId, rowId)
            .children[0].getBounds();
        return symBounds;
    }

    private setPositionsAndPivot = (
        multi: BitmapTextField,
        winBanner: BitmapMoneyField,
        winBannerMegaCluster: BitmapMoneyField,
        multiMegaCluster: BitmapTextField,
        x: number,
        y: number,
        paylineScene: SceneView
    ) => {
        // Make sure each text will be scaled from its center
        this.centerPivot(winBanner);
        this.centerPivot(multi);
        this.centerPivot(winBannerMegaCluster);
        this.centerPivot(multiMegaCluster);

        // Positioning the money fields.
        winBanner.position.set(x, y);
        winBannerMegaCluster.position.set(x, y);

        // Make sure everything fits the reel group bounds
        // this.ensureBounds(winBanner);
        // this.ensureBounds(winBannerMegaCluster);

        multi.pivot.set(multi.width / 2, 0);
        if (GameModel.isMobile()) {
            multi.pivot.set(multi.width / 2, -multi.height * 0.1);
        }

        multiMegaCluster.pivot.set(
            multiMegaCluster.width / 2,
            -multiMegaCluster.height / 2
        );

        multi.position.set(winBanner.position.x, winBanner.position.y);
        multiMegaCluster.position.set(
            winBannerMegaCluster.position.x,
            winBannerMegaCluster.position.y
        );
    };

    private getValueMegaTravelToSymbolPositions = (symbol, wild) => {
        return {
            x: symbol.x,
            y: symbol.y,
        };
    };

    private getMultiMegaTravelToSymbolPositions = (symbol, wild) => {
        return {
            x: symbol.x,
            y: symbol.y,
        };
    };

    private getWinBannerMegaClusterFinalPositions = (
        symbol,
        wild,
        winBannerMegaCluster
    ) => {
        return {
            x: symbol.x,
            y: symbol.y,
        };
    };

    private getMultiMegaClusterFinalPositions = (
        winBannerMegaCluster,
        multiMegaCluster
    ) => {
        // The win banner mega cluster and its multiplier
        // are relative each other, because we are using pixi anchor.
        // This means we can simply return the banner position here.
        return {
            x: winBannerMegaCluster.x,
            y: winBannerMegaCluster.y,
        };
    };

    private hasOverlappingMegaBounds() {
        let wins = SpinModel.getCurrentWinsData() as IWinData[];
        let rects = new Array<Rectangle>();
        wins.forEach((win) => {
            let rect = this.computeWinningSymbolsBound(win, false);
            rects.push(rect);
        });

        if (rects.length == 1) {
            return false;
        }

        for (let i = 0; i < rects.length; i++) {
            const currentRect = rects[i];
            const nextRect = rects[(i + 1) % rects.length];
            if (this.intersects(currentRect, nextRect)) {
                return true;
            }
        }

        return false;
    }

    /**
     * Checks whether two rects intersects each other.
     *
     * @private
     * @param {Rectangle} rect1
     * @param {Rectangle} rect2
     * @return {*}  {boolean}
     * @memberof BBWinlinesView
     */
    private intersects(rect1: Rectangle, rect2: Rectangle): boolean {
        const x0 = rect1.x < rect2.x ? rect2.x : rect1.x;
        const x1 = rect1.right > rect2.right ? rect2.right : rect1.right;

        if (x1 <= x0) {
            return false;
        }

        const y0 = rect1.y < rect2.y ? rect2.y : rect1.y;
        const y1 = rect1.bottom > rect2.bottom ? rect2.bottom : rect1.bottom;
        return y1 > y0;
    }

    private scaleMultiText(multi, winBanner) {
        let ratio = 0;
        ratio = multi.height / multi.width;
        multi.width = winBanner.height / ratio;
        multi.height = winBanner.height;
    }

    public addCustomTweens(
        winBanner,
        multi,
        value,
        scene,
        wild,
        winBannerMegaCluster?,
        multiMegaCluster?: BitmapTextField,
        lastBanner?,
        winData?
    ) {
        if (GameModel.isMobile()) {
            this.scaleMultiText(multi, winBanner);
        } else {
            multi.scale.set(
                winBanner.scale.x * this.multiScalars.upScaleMultiplier,
                winBanner.scale.y * this.multiScalars.upScaleMultiplier
            );
        }

        let winBannerCurrentScale = {
            x: winBanner.scale.x,
            y: winBanner.scale.y,
        };

        let multiCurrentScale = {
            x: multi.scale.x,
            y: multi.scale.y,
        };

        if (!!winBannerMegaCluster) {
            winBannerMegaCluster.scale.set(
                winBanner.scale.x * this.bannerScalars.upScaleMultiplier,
                winBanner.scale.y * this.bannerScalars.upScaleMultiplier
            );
        }
        if (!!multiMegaCluster) {
            multiMegaCluster.scale.set(
                winBanner.scale.x * this.multiScalars.upScaleMultiplier,
                winBanner.scale.y * this.multiScalars.upScaleMultiplier
            );
        }

        let tl = new TimelineMax({
            paused: true,
            onStart: () => {},
            onComplete: () => {
                App.instance.stage.children
                    .filter(
                        (x) =>
                            x.name &&
                            x.name.startsWith(this.debugDrawClusterBoundsPrefix)
                    )
                    .forEach((c) => {
                        App.instance.stage.removeChild(c);
                    });
            },
        });

        if (multi.text == "X1") {
            this.invokeX1Win(
                tl,
                winBannerCurrentScale,
                winBanner,
                multi,
                winBannerMegaCluster,
                multiMegaCluster,
                wild,
                scene,
                multiCurrentScale,
                value,
                winData,
                lastBanner
            );
        } else {
            this.invokeXNWin(
                tl,
                winBannerCurrentScale,
                winBanner,
                multi,
                winBannerMegaCluster,
                multiMegaCluster,
                wild,
                scene,
                multiCurrentScale,
                value,
                winData,
                lastBanner
            );
        }
        return tl;
    }

    private invokeX1Win(
        tl,
        winBannerCurrentScale,
        winBanner,
        multi,
        winBannerMegaCluster,
        multiMegaCluster,
        wild,
        scene,
        multiCurrentScale,
        value,
        winData,
        lastBanner
    ) {
        tl.add(
            TweenMax.to(winBanner.scale, this.popUpTime.max, {
                x:
                    winBannerCurrentScale.x *
                    this.bannerScalars.upScaleMultiplier,
                y:
                    winBannerCurrentScale.y *
                    this.bannerScalars.upScaleMultiplier,
                onStart: () => {
                    this.showAll([
                        winBanner,
                        multi,
                        winBannerMegaCluster,
                        multiMegaCluster,
                    ]);
                    SoundController.playSound("win_1", false, null, false);
                    // this.playWinSound();
                },
            }),
            0
        );
        if (wild && this.showX1MultiplierComboText) {
            this.invokeX1WinWild(
                tl,
                winBanner,
                multi,
                winBannerMegaCluster,
                multiMegaCluster,
                wild,
                scene,
                multiCurrentScale,
                value,
                winData,
                lastBanner
            );
        }
    }

    private invokeX1WinWild(
        tl,
        winBanner,
        multi,
        winBannerMegaCluster,
        multiMegaCluster,
        wild,
        scene,
        multiCurrentScale,
        value,
        winData,
        lastBanner
    ) {
        scene.addSubView(multi, "multi", "lines");
        tl.add(
            TweenMax.to(multi.scale, this.popUpTime.max * 3, {
                x: winBanner.scale.x * this.multiScalars.upScaleMultiplier,
                y: winBanner.scale.y * this.multiScalars.upScaleMultiplier,
            }),
            0
        );

        let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .getSubView("ReelGroup") as BBReelGroup;

        let symbol = reelGroup.getSymbolAt(wild.x == 0 ? 1 : wild.x == 7 ? 6 : wild.x, wild.y);
        //IF WILD IS ON THE LAST REEL OR THE FIRST -> THE WILD MEGA VALUES ARE CUT OFF BY THE FRAME SO I MOVE THEM A BIT TO THE SIDE
        //THIS IS THE NEW SUBVIEW POSITION AFTER THE TRAVEL

        let winBannerMegaClusterFinalPositions =
            this.getWinBannerMegaClusterFinalPositions(
                symbol,
                wild,
                winBannerMegaCluster
            );

        winBannerMegaCluster.x = winBannerMegaClusterFinalPositions.x;
        winBannerMegaCluster.y = winBannerMegaClusterFinalPositions.y;

        let multiMegaClusterFinalPositions =
            this.getMultiMegaClusterFinalPositions(
                winBannerMegaCluster,
                multiMegaCluster
            );

        multiMegaCluster.x = multiMegaClusterFinalPositions.x;
        multiMegaCluster.y = multiMegaClusterFinalPositions.y;

        this.winBannerMegaValue += value / winData.multiplier;
        winBannerMegaCluster.value = this.winBannerMegaValue;
        winBannerMegaCluster.visible = true;
        multiMegaCluster.visible = true;

        tl.add(
            TweenMax.to(winBanner, this.travelToWildTime, {
                //IF WILD IS ON THE LAST REEL OR THE FIRST -> THE WILD MEGA VALUES ARE CUT OFF BY THE FRAME SO I MOVE THEM A BIT TO THE SIDE
                x: winBannerMegaCluster.x,
                y: winBannerMegaCluster.y,
                onComplete: () => {
                    winBanner.visible = false;
                    if (scene.getSubView("megaBanner") != undefined) {
                        scene.removeSubView("megaBanner");
                    }
                    scene.addSubView(
                        winBannerMegaCluster,
                        "megaBanner",
                        "lines"
                    );
                },
            }),
            this.travelSumsToWildDelayTime
        );

        tl.add(
            TweenMax.to(multi, this.travelToWildTime, {
                x: multiMegaClusterFinalPositions.x,
                y: multiMegaClusterFinalPositions.y + this.multiplierSpacing,
                onComplete: () => {
                    this.playMultiplierSfx(lastBanner);
                    multi.visible = false;
                    let multipliers =
                        BBModel.getCurrentSpinProperty("multiplierBefore");
                    this.multiMegaValue *= multipliers[winData.winSymId - 1];
                    if (this.multiMegaValue > 1000) {
                        this.multiMegaValue = 1000;
                    }

                    multiMegaCluster.text = "X" + this.multiMegaValue;
                    if (lastBanner) {
                        tl.add(() => {
                            SoundController.playSound("win_amount", false, null, false);
                            winBannerMegaCluster.value =
                                this.winBannerMegaValue * this.multiMegaValue;
                            if (scene.getSubView("megaMulti") != undefined) {
                                scene.removeSubView("megaMulti");
                            }
                            this.multiMegaValue = 1;
                            this.winBannerMegaValue = 0;
                        }, 2);
                    }
                    multiMegaCluster.x = multiMegaClusterFinalPositions.x;
                    multiMegaCluster.y = multiMegaClusterFinalPositions.y;
                    if (scene.getSubView("megaMulti") != undefined) {
                        scene.removeSubView("megaMulti");
                    }
                    scene.addSubView(multiMegaCluster, "megaMulti", "lines");
                    // multiMegaCluster.scale.set(multi.upScaleMultiplier, multi.upScaleMultiplier);
                },
            }),
            this.travelSumsToWildDelayTime
        );
    }

    private invokeXNWin(
        tl,
        winBannerCurrentScale,
        winBanner,
        multi,
        winBannerMegaCluster,
        multiMegaCluster,
        wild,
        scene,
        multiCurrentScale,
        value,
        winData,
        lastBanner
    ) {
        tl.add(
            TweenMax.to(winBanner.scale, this.popUpTime.max, {
                x:
                    winBannerCurrentScale.x *
                    this.bannerScalars.upScaleMultiplier,
                y:
                    winBannerCurrentScale.y *
                    this.bannerScalars.upScaleMultiplier,
                onStart: () => {
                    this.showAll([
                        winBanner,
                        multi,
                        winBannerMegaCluster,
                        multiMegaCluster,
                    ]);
                    SoundController.playSound("win_1", false, null, false);
                    // this.playWinSound();
                },
            }),
            0
        );
        scene.addSubView(multi, "multi", "lines");
        tl.add(
            TweenMax.to(multi.scale, this.travelToWildTime, {
                x: winBanner.scale.x * this.multiScalars.upScaleMultiplier,
                y: winBanner.scale.y * this.multiScalars.upScaleMultiplier,
            }),
            0
        );
        tl.add(
            TweenMax.to(multi, this.popUpTime.max, {
                delay: 0.6,
                onComplete: () => {
                    if (!wild) {
                        winBanner.value = value;
                        SoundController.playSound("win_amount", false, null, false);
                    }
                    // SoundController.playSound('multiplier_amount')
                },
            }),
            0
        );
        if (wild) {
            tl.add(
                TweenMax.to(multi, this.travelToWildTime, {
                    delay: 0.8,
                    onComplete: () => {
                        if (!wild) {
                            if (scene.getSubView("multi") != undefined) {
                                scene.removeSubView("multi");
                            }
                        }
                    },
                }),
                0
            );
        } else {
            tl.add(
                TweenMax.to(multi, this.travelToWildTime, {
                    alpha: 0,
                    y: multi.y - multi.height,
                    delay: 0.8
                }),
                0
            );

            tl.add(
                TweenMax.to(winBanner.scale, 0.2, {
                    yoyo: true,
                    x: winBanner.scale.x * 0.95,
                    y: winBanner.scale.y * 0.95,
                    delay: 0.6,
                    repeat: 1,
                }),
                0
            );
        }

        if (wild) {
            this.invokeXNWinWild(
                tl,
                winBannerCurrentScale,
                winBanner,
                multi,
                winBannerMegaCluster,
                multiMegaCluster,
                wild,
                scene,
                value,
                winData,
                lastBanner
            );
        }
    }

    private invokeXNWinWild(
        tl,
        winBannerCurrentScale,
        winBanner,
        multi,
        winBannerMegaCluster,
        multiMegaCluster,
        wild,
        scene,
        value,
        winData,
        lastBanner
    ) {
        let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .getSubView("ReelGroup") as BBReelGroup;


        let symbol = reelGroup.getSymbolAt(wild.x == 0 ? 1 : wild.x == 7 ? 6 : wild.x, wild.y);

        //THIS IS THE NEW SUBVIEW POSITION AFTER THE TRAVEL
        let winBannerMegaClusterFinalPositions =
            this.getWinBannerMegaClusterFinalPositions(
                symbol,
                wild,
                winBannerMegaCluster
            );

        winBannerMegaCluster.x = winBannerMegaClusterFinalPositions.x;
        winBannerMegaCluster.y = winBannerMegaClusterFinalPositions.y;

        let multiMegaClusterFinalPositions =
            this.getMultiMegaClusterFinalPositions(
                winBannerMegaCluster,
                multiMegaCluster
            );

        multiMegaCluster.x = multiMegaClusterFinalPositions.x;
        multiMegaCluster.y = multiMegaClusterFinalPositions.y;

        this.winBannerMegaValue += value / winData.multiplier;
        winBannerMegaCluster.value = this.winBannerMegaValue;
        winBannerMegaCluster.visible = true;
        multiMegaCluster.visible = true;

        tl.add(
            TweenMax.to(winBanner, this.travelToWildTime, {
                x: winBannerMegaCluster.x,
                y: winBannerMegaCluster.y,
                onComplete: () => {
                    winBanner.visible = false;
                    if (scene.getSubView("megaBanner") != undefined) {
                        scene.removeSubView("megaBanner");
                    }
                    scene.addSubView(
                        winBannerMegaCluster,
                        "megaBanner",
                        "lines"
                    );
                },
            }),
            1
        );

        tl.add(
            TweenMax.to(multi, this.travelToWildTime, {
                x: multiMegaClusterFinalPositions.x,
                y: multiMegaClusterFinalPositions.y + this.multiplierSpacing,
                onComplete: () => {
                    this.playMultiplierSfx(lastBanner);
                    multi.visible = false;
                    let multipliers =
                        BBModel.getCurrentSpinProperty("multiplierBefore");
                    this.multiMegaValue *= multipliers[winData.winSymId - 1];
                    if (this.multiMegaValue > 1000) {
                        this.multiMegaValue = 1000;
                    }

                    multiMegaCluster.text = "X" + this.multiMegaValue;
                    multiMegaCluster.x = multiMegaClusterFinalPositions.x;
                    multiMegaCluster.y = multiMegaClusterFinalPositions.y;

                    if (lastBanner) {
                        tl.add(() => {
                            winBannerMegaCluster.value =
                                this.winBannerMegaValue * this.multiMegaValue;
                            SoundController.playSound("win_amount", false, null, false);
                            if (scene.getSubView("megaMulti") != undefined) {
                                SoundController.playSound(
                                    "multiplier_amount",
                                    false,
                                    null,
                                    false
                                );
                                scene.removeSubView("megaMulti");
                            }
                            this.multiMegaValue = 1;
                            this.winBannerMegaValue = 0;
                        }, 2);

                        tl.add(
                            TweenMax.to(
                                multiMegaCluster,
                                this.travelToWildTime,
                                {
                                    alpha: 0,
                                    y:
                                        multiMegaCluster.y -
                                        multiMegaCluster.height,
                                    delay: 0.8,
                                }
                            ),
                            1
                        );

                        tl.add(
                            TweenMax.to(winBannerMegaCluster.scale, 0.2, {
                                yoyo: true,
                                x: winBannerMegaCluster.scale.x * 0.85,
                                y: winBannerMegaCluster.scale.y * 0.85,
                                delay: 0.6,
                                repeat: 1,
                            }),
                            1
                        );
                    }

                    if (scene.getSubView("megaMulti") != undefined) {
                        scene.removeSubView("megaMulti");
                    }
                    scene.addSubView(multiMegaCluster, "megaMulti", "lines");
                    // multiMegaCluster.scale.set(this.multiScalars.upScaleMultiplier, this.multiScalars.upScaleMultiplier);
                    // winBannerMegaCluster.scale.set(winBannerCurrentScale.x * this.multiScalars.upScaleMultiplier, winBannerCurrentScale.y * this.multiScalars.upScaleMultiplier)
                },
            }),
            1
        );
    }

    protected playMultiplierSfx(lastBanner: boolean) {
        const multiplier = Math.min(4, this.multiSfxCounter);
        // console.log("multiplier:", multiplier);
        SoundController.playSound("multiplier_applied_lv" + multiplier, false, null, false);

        // Reset the multiplierSfx counter if this is the last banner
        if (lastBanner) {
            // console.log("This is the last banner!");
            this.multiSfxCounter = 1;
        } else {
            this.multiSfxCounter++;
        }
    }

    public changeColor(
        winBanner: BitmapMoneyField,
        multi: BitmapTextField,
        winData
    ) {
        let color =
            this.useSingleMegaColorOnOverlap && this.hasOverlappingMegaBounds()
                ? this.colorMap[0]
                : this.colorMap[winData.winSymId];

        let newStyle = Utils.deepClone(
            winBanner.style
        ) as BitmapMoneyFieldConfig;
        newStyle.fontFamily = color;
        winBanner.style = newStyle;
        multi.element.font = color;
    }

    public centerPivot(object: DisplayObject) {
        let bounds = object.getLocalBounds();
        object.pivot.set(bounds.width / 2, bounds.height / 2);
    }
}
